module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAABVklEQVQ4T7WUvytFYRjHP9+SQVabMtksyo+yIiQlmZjcRTYlA2Uzm5QySFaLYiGpu2CUzeBG7sA/ID+GR8/tfW8nnXs753buGd+e9/N+n+/3eY4o+FPBPOpAM+sARoDOFh55lvTm92pAM+sFboEq8JMT6AL6gUFJ1QhcAQYkbeSE1crNbA94lHQcgatAj6TdFoE7wIekw/YDzawPOAC2JT1kUWxm6QqBC+Ac2AfWgZks0EbABQ8GWJR0Z2ZjwCkwG6Fm1g3cAN/AlKTPEEqqQj8cl/QU2zSzYeDMoUAFuA5duPcTwKSkr4Ytp6WcgL4DV5K2giq3ZC48tpkr5QB1f0clvSQ6WHOLgHvgNdfYBOhJCCoJLcUQcwFDm+6pQ907X9O4Kb5pFUnlONjLwDywJOm32ewFpUdBaR0a70RgF1AGhrIMcqi5lDT9v759/8McypqWFq7wD39zshVZM1PpAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/img/texture.png
// module id = PaSS
// module chunks = 1